import { ReferenceTypes } from "app/store/BillingUsage/BillingUsage.types";
import { IUsage, IGroupByCaseService } from "app/store/BillingUsage/BillingUsage.models";

export default function useGroupByCaseService(usages:IUsage[]):IGroupByCaseService[] {
  // Use a Map for efficient grouping by caseId
  const caseMap = new Map<string, IGroupByCaseService>();

  for (const cur of usages || []) {
    const caseReference = cur.reference?.type === ReferenceTypes.Case ? cur.reference : null;
    if (!caseReference || !cur.service) continue;

    const id = caseReference.value;
    const name = caseReference.name;
    const { service, quantity, amount, invoices } = cur;

    let caseEntry = caseMap.get(id);
    if (!caseEntry) {
      caseEntry = { id, name, services: [], invoices };
      caseMap.set(id, caseEntry);
    }

    const existingService = caseEntry.services.find(s => s.id === service.id);
    if (existingService) {
      existingService.quantity += quantity;
      existingService.amount += amount;
    } else {
      caseEntry.services.push({
        id: service.id,
        name: service.name,
        quantity,
        amount,
      });
    }
  }

  // Convert Map to array and sort
  const groupedData = Array.from(caseMap.values()).map(caseData => ({
    ...caseData,
    totalAmount: caseData.services.reduce((sum, s) => sum + s.amount, 0),
  }));

  groupedData.forEach(caseData => {
    caseData.services.sort((a, b) => b.amount - a.amount);
  });

  return groupedData
    .sort((a, b) => b.totalAmount - a.totalAmount)
    .map(({ totalAmount, ...caseData }) => caseData);
}